export const hash = 'fde187c8-c63c-4523-8f34-e83ff5bc50e5';

// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v2.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br/';
//export const apiSocket = 'http://localhost:8080';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const urlWebsite = 'https://neonatologia.encontrodigital.com.br';
export const defaultProjectHash = 'neonatologia-2022';
export const supportNumber = `5551981476007`;



export const home = 'Home';
export const haveTranslate = false;
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'VIII Encontro Internacional de Neonatologia e VI Simpósio Interdisciplinar de Atenção ao Prematuro';
export const logo = '/assets/logo1.png';
export const background = '/assets/Fundo.jpeg';
export const authTitle = 'VIII Encontro Internacional de Neonatologia e VI Simpósio Interdisciplinar de Atenção ao Prematuro';
export const dadosOrganizacao = '';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};


export const defaultTheme = {
  defaultBackground: 'rgb(0,50,150)',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: '#fff',
    backgroundSticky: '#fff',
    backgroundMobile: 'rgb(0,50,150)',
    color: 'rgb(0, 14, 64)',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
